// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentServiceV2PublicModelsRulesMetaRuleResultModel {
    static getAttributeTypeMap() {
        return EnrollmentServiceV2PublicModelsRulesMetaRuleResultModel.attributeTypeMap;
    }
}
EnrollmentServiceV2PublicModelsRulesMetaRuleResultModel.discriminator = undefined;
EnrollmentServiceV2PublicModelsRulesMetaRuleResultModel.attributeTypeMap = [
    {
        "name": "bypassRuleTypeCode",
        "baseName": "bypassRuleTypeCode",
        "type": "string"
    },
    {
        "name": "bypassRuleCode",
        "baseName": "bypassRuleCode",
        "type": "string"
    }
];
//# sourceMappingURL=enrollmentServiceV2PublicModelsRulesMetaRuleResultModel.js.map